/* eslint-disable camelcase */
import React, {
    useContext, useEffect, useMemo, useState, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { isStandaloneApp } from 'app/utils/browser';

// eslint-disable-next-line max-len
import { BottomOpeningSelect } from 'app/views/Profile/__NextProfile/ProfileDeliveriesPage/components/DeliveryEditForms/CommonСomponents/BottomOpeningSelect';
import { UIButtonV2, UIRadioIconV2 } from 'app/components/ui';
import { Portal } from 'react-portal';
import { Desktop, Mobile } from 'app/components/Responsive';
import { isDesktop } from 'app/utils/resolution';
import { marchgifts } from 'app/assets/dishesSelections/dishesSelections';
import Arrow from './assets/arrow.component.svg';
import { formatStringUnits } from '../../../scripts/formatStringUnits';
import { BasketContext } from '../BasketProvider';
import { NYGiftContext } from '../NYGiftContext';
import closeCrossIcon from './closeCross.image.svg';
import './dots.scss';


import plusIconPath from './assets/plus.image.svg';
import minusIconPath from './assets/minus.image.svg';
import { ConfigContext } from '../ConfigProvider';


export const OrderButton = ({
    text = 'Заказать',
    linkUrl = null,
    onClick = null,
    isOpenDetailsHandler = false,
    withCustomizationSelect = false,
}) => {
    const { pageId } = useContext(ConfigContext);
    const commonProps = useMemo(() => ({
        className: 'ny__dish__order-button',
        type: 'button',
        onClick,
    }), [onClick]);

    const containerClasses = classNames({
        'ny__dish__add-button__container': true,
        'order-button': true,
        'js-open-details-button': isOpenDetailsHandler,
        withCustomizationSelect,
        [pageId]: true,
    });

    const linkContainerClasses = classNames({
        'ny__dish__order-button': true,
        [pageId]: true,
    });

    return (
        <div className={containerClasses}>
            {linkUrl
                ? (
                    <a
                        href={linkUrl}
                        target={isStandaloneApp() ? '_self' : '_blank'}
                        rel="noopener noreferrer"
                        className={linkContainerClasses}
                    >
                        <div>{text}</div>
                        {pageId === 'marchgifts' && (
                            <div className="ny__dish__order-button_arrow">
                                <Arrow />
                            </div>
                        )}
                    </a>
                )
                : (
                    <button type="button" {...commonProps}>
                        {text}
                    </button>
                )}
        </div>
    );
};
OrderButton.propTypes = {
    text: PropTypes.string,
    linkUrl: PropTypes.string,
    isOpenDetailsHandler: PropTypes.bool,
    onClick: PropTypes.func,
};

const dishWithWrapMetaRecord = {
    3897: {
        popUpTitle: 'коврижки',
    },

    3835: {
        popUpTitle: 'кантуччи',
    },
};

const priceRecord = {
    gingerbread: {
        firstRowPrice: '100 ₽',
        secondRowPrice: 'бесплатно',
    },
    cantucci: {
        firstRowPrice: 'бесплатно',
        secondRowPrice: 'со скидкой 100 ₽',
    },

};


const GiftWrapComponent = (props) => {
    const {
        giftWrapId,
        id,
        setTransitionDialogState,
        onClickAddToBasket,
        updateBasket,
        addHeadItem,
        modedItemsCount,
        commonItemsCount,
        dishCountStep,
    } = props;

    const [selectedId, setSelectedId] = useState(null);
    const { getItemsListById } = useContext(NYGiftContext);
    const { isGiftItemSelected, name, setIsGiftItemSelected } = getItemsListById(giftWrapId);

    useEffect(
        () => {
            const firstId = name === 'gingerbread' ? id : giftWrapId;
            const isGiftSelected = firstId === giftWrapId;

            setSelectedId(firstId);
            setIsGiftItemSelected(isGiftSelected);
        },
        // didMount, setting inititial state
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    const { firstRowPrice, secondRowPrice } = useMemo(() => priceRecord[name], [name]);

    /* HANDLERS */
    function handleSelectDish(nextId) {
        const { setIsGiftItemSelected: setSelected } = getItemsListById(nextId);
        setSelectedId(nextId);

        const isGiftSelected = nextId === giftWrapId;
        setSelected(isGiftSelected);
    }

    const handleAddToBasket = () => {
        const count = selectedId === giftWrapId ? modedItemsCount : commonItemsCount;
        onClickAddToBasket({ id: selectedId, portions: count + dishCountStep });
        updateBasket({
            dishId: selectedId,
            portions: count + dishCountStep,
            onCompletedCallback: () => {
                addHeadItem(selectedId);
                setTransitionDialogState('exiting');
            },
        });
    };

    /* SELECTORS */

    const { popUpTitle } = useMemo(() => dishWithWrapMetaRecord[giftWrapId], [giftWrapId]);

    const dotsDividerClasses = classNames({
        'gift-wrap-with--dots': true,
        'dots-divider': true,
    });

    const giftWrapRootDefaultClasses = classNames({
        giftWrapContentSelectionItem: true,
        selected: selectedId === id,
    });


    const giftWrapRootWithgiftClasses = classNames({
        giftWrapContentSelectionItem: true,
        selected: selectedId === giftWrapId,
    });

    return (
        <div className="giftWrapContentRoot">
            <div className="giftWrapContentTitle">
                <p className="giftWrapContentTitleText">
                    Упаковка для
                    {' '}
                    {popUpTitle}
                </p>
                <Desktop>
                    <button
                        onClick={() => { setTransitionDialogState('exiting'); }}
                        type="button"
                        className="giftWrapContentCloseButton"
                    >
                        <img src={closeCrossIcon} alt="" />
                    </button>
                </Desktop>
            </div>
            <div className="giftWrapContentSelection">
                <button
                    className={giftWrapRootWithgiftClasses}
                    type="button"
                    onClick={() => handleSelectDish(giftWrapId)}
                    id={giftWrapId}
                >
                    <div className="giftWrapContentSelectionItemAbout">
                        <Mobile>
                            Подарочная
                        </Mobile>
                        <Desktop>
                            Подарочная упаковка
                        </Desktop>
                    </div>
                    <div className={dotsDividerClasses} />
                    <div className="giftWrapContentSelectionItemPrice">
                        <div className="giftWrapContentSelectionItemPriceText">
                            {firstRowPrice}
                        </div>
                        <UIRadioIconV2 checked={isGiftItemSelected} />
                    </div>
                </button>
                {/*  */}
                <button
                    className={giftWrapRootDefaultClasses}
                    type="button"
                    onClick={() => handleSelectDish(id)}
                    id={id}
                >
                    <div className="giftWrapContentSelectionItemAbout">
                        <Mobile>
                            Обычная
                        </Mobile>
                        <Desktop>
                            Обычная упаковка
                        </Desktop>
                    </div>
                    <div className={dotsDividerClasses} />
                    <div className="giftWrapContentSelectionItemPrice">
                        <div className="giftWrapContentSelectionItemPriceText">
                            {secondRowPrice}
                        </div>
                        <UIRadioIconV2 checked={!isGiftItemSelected} />
                    </div>
                </button>
            </div>
            <div className="giftWrapContentSelectionButton">
                <UIButtonV2
                    onClick={handleAddToBasket}
                    disabled={false}
                // disabledColor="primary-melon"
                // loading={isSubmitLoading}
                >
                    Добавить
                </UIButtonV2>
            </div>
        </div>
    );
};

const romanticBrunchDishes = ['1645', '2971'];
const romanticDessertDishes = ['3478', '4102'];
const romanticSnacksDishes = ['4315', '5252'];
const romanticMainDishes = ['4317', '5253'];

const categoriesDishesMap = {
    snacks: romanticSnacksDishes,
    main: romanticMainDishes,
};

const AddButton = (props) => {
    /* eslint-disable react/prop-types */
    const {
        hasStaticPositon,
        originalPriceWithStep,
        discountPriceWithStep,
        price,
        portionsCount,
        isInfoBlock,
        buttonsDisabled,
        onClickIncreade,
        onClickDecrease,
        className,
        withToggle,
        pageId,
        id,
        withCustomizationSelect = false,
        thin = false,
    } = props;

    /* eslint-enable react/prop-types */
    const [isDesktopResolution, setIsDesktopResolution] = useState(isDesktop());

    const checkDesktopResolution = useCallback(
        () => setIsDesktopResolution(isDesktop()),
        [],
    );

    const isRomanticPage = pageId === 'romantic';

    const isShortButton = withToggle ? false : (originalPriceWithStep === discountPriceWithStep && portionsCount === 0);

    const containerClasses = classNames({
        'ny__dish__add-button__container': true,
        withToggle,
        withCustomizationSelect,
        thin,
        'short-button': isShortButton,
        'has-discount': originalPriceWithStep !== discountPriceWithStep && portionsCount === 0,
        'with-enlarge-animation': portionsCount > 0,
        'with-downsize-animation': portionsCount === 0,
        'dish-added': withToggle ? true : portionsCount > 0,
        'add-disabled': (isRomanticPage && romanticDessertDishes.includes(id)) || (withToggle && portionsCount === 0),
        'without-info-block': !isInfoBlock,
        'has-static-position': hasStaticPositon,
        [className]: !isDesktopResolution,
        [pageId]: true,
    });

    useEffect(
        () => {
            window.addEventListener(
                'resize',
                checkDesktopResolution,
            );
            return () => {
                window.removeEventListener('resize', checkDesktopResolution);
            };
        },
        [checkDesktopResolution],
    );

    const isOriginalPriceShown = originalPriceWithStep !== discountPriceWithStep
        && parseInt(originalPriceWithStep, 10) > parseInt(discountPriceWithStep, 10);

    const firstPortionLine = withToggle && !isRomanticPage ? `0 x ${price}` : discountPriceWithStep;

    const isManyDigitString = price.toString().split('').length >= 5;

    const dishButtonClasses = classNames({
        'ny__dish__add-button__left-container': true,
        manyDigitString: isManyDigitString,
    });

    const decreaseButtonClasses = classNames({
        'ny__dish__add-button__decrease-button': true,
        manyDigitString: isManyDigitString,
    });

    const increaseButtonClasses = classNames({
        'ny__dish__add-button__increase-button': true,
        manyDigitString: isManyDigitString,
    });

    const dishButtonClassesPrice = classNames({
        'ny__dish__add-button__container__discounted-price': true,
        [pageId]: true,

    });
    const isRomanticDessert = isRomanticPage && romanticDessertDishes.includes(id);
    const isPriceShown = (isRomanticPage && romanticBrunchDishes.includes(id)) || !isRomanticPage;

    return (
        <div
            className={containerClasses}
            onClick={isShortButton
                ? onClickIncreade
                : (e) => {
                    if (!portionsCount) {
                        onClickIncreade(e);
                    }
                }
            }
            role="none"
        >
            <div className="ny__dish__add-button__left-side-container">
                <div className={dishButtonClasses}>
                    <span className="ny__dish__add-button__original-price">
                        {!isOriginalPriceShown
                            ? null
                            : (
                                <>
                                    <span className="num">{originalPriceWithStep}</span>
                                    ₽
                                </>
                            )
                        }
                    </span>

                    {(isRomanticPage && !!portionsCount && !isRomanticDessert) && (
                        <button
                            onClick={onClickDecrease}
                            type="button"
                            disabled={false}
                            className={decreaseButtonClasses}
                        >
                            <img src={minusIconPath} alt="" className="minusIcon" />
                        </button>
                    )}
                    {!isRomanticPage && (
                        <button
                            onClick={onClickDecrease}
                            type="button"
                            disabled={!withToggle ? buttonsDisabled : false}
                            className={decreaseButtonClasses}
                        >
                            -
                        </button>
                    )}
                </div>
                {((!withToggle && !thin) || (thin && portionsCount < 1)) && (
                    <button
                        className={dishButtonClassesPrice}
                        onClick={onClickIncreade}
                        type="button"
                        disabled={isRomanticDessert || buttonsDisabled}
                    >
                        {isPriceShown && (
                            <span className="num">
                                {portionsCount > 0 && `${portionsCount} x ${price}`}
                                {!portionsCount && firstPortionLine}
                            </span>
                        )}
                        &nbsp;
                        {isPriceShown && '₽'}
                        {!isPriceShown && !isRomanticDessert && `${formatStringUnits(portionsCount, ['порция', 'порции', 'порций'])}`}

                        {pageId === 'romantic'
                            && <div className="desription">{portionsCount ? 'Уже добавлен в бокс' : 'Добавить в бокс'}</div>}
                    </button>
                )}
            </div>
            {(withToggle || (thin && portionsCount > 0)) && (
                <button
                    className={dishButtonClassesPrice}
                    onClick={onClickIncreade}
                    type="button"
                    disabled={isRomanticDessert || buttonsDisabled}
                >
                    {isPriceShown && (
                        <span className="num">
                            {portionsCount > 0 && `${portionsCount} x ${price}`}
                            {!portionsCount && firstPortionLine}
                        </span>
                    )}
                    {!isPriceShown && !isRomanticDessert && `${formatStringUnits(portionsCount, ['порция', 'порции', 'порций'])}`}
                    {/* &nbsp;₽ */}
                    {pageId === 'romantic' && !isRomanticDessert && (
                        <div className="desription">
                            {portionsCount
                                ? 'Уже добавлен в бокс'
                                : 'Добавить в бокс'
                            }
                        </div>
                    )}
                    {pageId === 'romantic' && isRomanticDessert && (
                        <div className="desription">
                            Всегда в наборе
                        </div>
                    )}
                    {pageId === 'romantic' && portionsCount > 0 && (
                        <div className="changePortionContainer">
                            <div
                                className="changePortionContainerItem"
                                onClick={onClickDecrease}
                                role="none"
                            />
                            <div
                                className="changePortionContainerItem"
                                onClick={onClickIncreade}
                                role="none"
                            />
                        </div>
                    )}
                </button>
            )}

            {(isRomanticPage && !!portionsCount && !isRomanticDessert) && (
                <button
                    className={increaseButtonClasses}
                    type="button"
                    disabled={false}
                    onClick={onClickIncreade}
                >
                    <img src={plusIconPath} alt="" className="plusIcon" />
                </button>
            )}
            {!isRomanticPage && (
                <button
                    className={increaseButtonClasses}
                    type="button"
                    disabled={!withToggle ? (isRomanticDessert || buttonsDisabled) : false}
                    onClick={onClickIncreade}
                >
                    +
                </button>
            )}
        </div>
    );
};

const noop = () => { };

function DishButton({
    id,
    portion,
    dishCountStep,
    maxPortion = 9,
    onClickAddToBasket = noop,
    hasStaticPositon = false,
    className,
    // NY2024
    giftWrapId = undefined,
    realm = 'ANY',
    isChecked = null,

    discountPriceWithStep,
    originalPriceWithStep,
    price,
    isDishRemovingDisabled,
    pageId,
    categoryId,

    // isSet = false,
    // dishes = [],
    ...restProps
}) {
    const isNeedToCheckPairs = pageId === 'romantic' && (categoryId === 'main' || categoryId === 'snacks');

    const { updateBasket } = useContext(BasketContext);
    // NY2024
    /* FRNT-3400 ПОДАРОЧНАЯ УПАКОВКА */
    const {
        removeHeadItem,
        addHeadItem,
        // itemsList,
        getItemsListById,
        isGiftItem,
    } = useContext(NYGiftContext);

    const [transitionDialogState, setTransitionDialogState] = useState('exited');
    const { itemsList } = getItemsListById(id, giftWrapId);
    // const itemsList = getItemsListById(id, giftWrapId);

    const getItemsCount = (id, giftId) => {
        if (!giftId) {
            return {
                commonItemsCount: 0, modedItemsCount: 0,
            };
        }

        const commonItemsCount = itemsList.filter((item) => item === id).length;
        const modedItemsCount = itemsList.filter((item) => item === giftId).length;
        return { commonItemsCount, modedItemsCount };
    };

    const { commonItemsCount, modedItemsCount } = getItemsCount(id, giftWrapId);

    // const commonItemsCount = itemsList.filter((item) => item === '3835').length;

    // eslint-disable-next-line arrow-body-style
    // const modedItemsCount = itemsList.filter((item) => item === '4211').length;

    const portionsCountWith_gift_dish = useMemo(() => {
        if (isGiftItem(id)) {
            // eslint-disable-next-line arrow-body-style
            return modedItemsCount + commonItemsCount;
        }
        const portionsCount = (portion > maxPortion)
            ? maxPortion
            : portion;
        return portionsCount;
    }, [portion, id, maxPortion, modedItemsCount, commonItemsCount, isGiftItem]);

    const handleClickIncrease = (e) => {
        e.stopPropagation();
        if (portion >= maxPortion) return;
        // console.log(lastItemId);

        // FRNT-3400 Упаковка
        if (giftWrapId && realm === 'ANY') {
            setTransitionDialogState('entering');
        } else if (realm === 'DISH_DETAILS') {
            const commonPortionCount = commonItemsCount + dishCountStep;
            const modedPortionCount = modedItemsCount + dishCountStep;
            const portionCount = isChecked ? modedPortionCount : commonPortionCount;

            updateBasket({
                dishId: isChecked ? giftWrapId : id,
                portions: portionCount,
                onCompletedCallback: () => {
                    addHeadItem(isChecked ? giftWrapId : id);
                },
            });
        } else {
            const nextCount = portion + dishCountStep;
            onClickAddToBasket({ id, portions: nextCount });
            updateBasket({ dishId: id, portions: nextCount });
        }
    };

    const handleClickDecrease = (e) => {
        e.stopPropagation();
        // FRNT-3400 Упаковка
        if (giftWrapId) {
            // const nextCount = itemsList.length - dishCountStep;
            const lastId = removeHeadItem(giftWrapId);
            const nextCountById = isGiftItem(giftWrapId) ? modedItemsCount : commonItemsCount;

            if (nextCountById === 0 && isDishRemovingDisabled) return;

            updateBasket({ dishId: lastId, portions: nextCountById - dishCountStep });
            // updateBasket({ dishId: giftWrapId, portions: nextCount });
        } else {
            const nextCount = portion - dishCountStep;
            if (isNeedToCheckPairs && nextCount === 0) {
                const currentCategoryDishes = categoriesDishesMap[categoryId];
                const anotherPairDish = currentCategoryDishes.find((d) => d !== id);
                updateBasket({ dishId: id, portions: nextCount });
                if (anotherPairDish) {
                    updateBasket({ dishId: anotherPairDish, portions: 2 });
                }
                return;
            }
            if (nextCount < 0) return;
            updateBasket({ dishId: id, portions: nextCount });
        }
    };

    const { originalPriceWithGift, discountPriceWithGift, priceWithGift } = useMemo(() => {
        if (giftWrapId) {
            const { isGiftItemSelected } = getItemsListById(id);
            return {
                originalPriceWithGift: !isGiftItemSelected ? originalPriceWithStep : Number(originalPriceWithStep) + 100,
                discountPriceWithGift: !isGiftItemSelected ? discountPriceWithStep : Number(discountPriceWithStep) + 100,
                priceWithGift: !isGiftItemSelected ? price : Number(price) + 100,
            };
        }

        return {
            originalPriceWithGift: originalPriceWithStep,
            discountPriceWithGift: discountPriceWithStep,
            priceWithGift: price,
        };
    }, [getItemsListById, giftWrapId, id, discountPriceWithStep, originalPriceWithStep, price]);

    return (
        <>
            {giftWrapId
                && (
                    <Portal>
                        <BottomOpeningSelect
                            transition={transitionDialogState}
                            ctx="nyPage"
                            closeHandler={() => { setTransitionDialogState('exiting'); }}
                        >
                            <GiftWrapComponent
                                giftWrapId={giftWrapId}
                                id={id}
                                setTransitionDialogState={setTransitionDialogState}
                                onClickAddToBasket={onClickAddToBasket}
                                updateBasket={updateBasket}
                                addHeadItem={addHeadItem}
                                itemsList={itemsList}
                                commonItemsCount={commonItemsCount}
                                modedItemsCount={modedItemsCount}
                                dishCountStep={dishCountStep}
                            />
                        </BottomOpeningSelect>
                    </Portal>
                )}
            <AddButton
                {...restProps}
                hasStaticPositon={hasStaticPositon}
                portionsCount={portionsCountWith_gift_dish}
                onClickIncreade={handleClickIncrease}
                onClickDecrease={handleClickDecrease}
                discountPriceWithStep={discountPriceWithGift}
                originalPriceWithStep={originalPriceWithGift}
                price={priceWithGift}
                className={className}
                pageId={pageId}
                id={id}
            />
        </>
    );
}

export default React.memo(DishButton);

DishButton.propTypes = {
    hasStaticPositon: PropTypes.bool,

    id: PropTypes.string.isRequired,
    giftWrapId: PropTypes.string,
    // isSet: PropTypes.bool,
    // dishes: PropTypes.arrayOf(PropTypes.string),
    dishCountStep: PropTypes.number.isRequired,
    originalPriceWithStep: PropTypes.string.isRequired,
    discountPriceWithStep: PropTypes.string.isRequired,
    isInfoBlock: PropTypes.bool.isRequired,
    portion: PropTypes.number.isRequired,
    maxPortion: PropTypes.number,
    buttonsDisabled: PropTypes.bool.isRequired,
    onClickAddToBasket: PropTypes.func,
};
